const DeleteIcon = (props: {fill?: string}) => {
  const fill = props.fill || 'white';
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.03846 1.90846H6.92308V1.52384C6.92308 0.887615 6.40546 0.369995 5.76923 0.369995H4.23077C3.59454 0.369995 3.07692 0.887615 3.07692 1.52384V1.90846H0.961538C0.431346 1.90846 0 2.3398 0 2.87V4.21615C0 4.42855 0.172212 4.60076 0.384615 4.60076H0.594808L0.927091 11.5787C0.956442 12.195 1.46269 12.6777 2.07962 12.6777H7.92038C8.53733 12.6777 9.04358 12.195 9.07291 11.5787L9.40519 4.60076H9.61538C9.82779 4.60076 10 4.42855 10 4.21615V2.87C10 2.3398 9.56865 1.90846 9.03846 1.90846ZM3.84615 1.52384C3.84615 1.31177 4.0187 1.13923 4.23077 1.13923H5.76923C5.9813 1.13923 6.15385 1.31177 6.15385 1.52384V1.90846H3.84615V1.52384ZM0.769231 2.87C0.769231 2.76396 0.855505 2.67769 0.961538 2.67769H9.03846C9.1445 2.67769 9.23077 2.76396 9.23077 2.87V3.83153C9.11224 3.83153 1.26041 3.83153 0.769231 3.83153V2.87ZM8.30454 11.5421C8.29476 11.7475 8.12601 11.9085 7.92038 11.9085H2.07962C1.87397 11.9085 1.70522 11.7475 1.69546 11.5421L1.3649 4.60076H8.6351L8.30454 11.5421Z"
        fill={fill}
      />
      <path
        d="M5.00009 11.1392C5.2125 11.1392 5.38471 10.967 5.38471 10.7546V5.75461C5.38471 5.54221 5.2125 5.37 5.00009 5.37C4.78769 5.37 4.61548 5.54221 4.61548 5.75461V10.7546C4.61548 10.967 4.78767 11.1392 5.00009 11.1392Z"
        fill={fill}
      />
      <path
        d="M6.92319 11.1392C7.13559 11.1392 7.30781 10.967 7.30781 10.7546V5.75461C7.30781 5.54221 7.13559 5.37 6.92319 5.37C6.71079 5.37 6.53857 5.54221 6.53857 5.75461V10.7546C6.53857 10.967 6.71076 11.1392 6.92319 11.1392Z"
        fill={fill}
      />
      <path
        d="M3.077 11.1392C3.2894 11.1392 3.46161 10.967 3.46161 10.7546V5.75461C3.46161 5.54221 3.2894 5.37 3.077 5.37C2.86459 5.37 2.69238 5.54221 2.69238 5.75461V10.7546C2.69238 10.967 2.86457 11.1392 3.077 11.1392Z"
        fill={fill}
      />
    </svg>
  );
};

export default DeleteIcon;
